export const colors: [number, number, number][] = [
  [100, 181, 246],
  [230, 159, 0],
  [0, 158, 115],
  [240, 228, 66],
  [0, 114, 178],
  [213, 94, 0],
  [204, 121, 167],
  [105, 105, 105],
];

export const colorCount = colors.length;

export const styleColors: string[] = colors.map(
  color => `rgb(${color.join(',')})`,
);

export const appendStyleSheet = () => {
  const node = document.createElement('style');
  node.setAttribute('type', 'text/css');
  node.setAttribute('id', 'accessible-color-palette');
  node.innerHTML = `:root {
${colors
  .map(
    (color, index) => `  --accessible-color-${index + 1}: ${color.join(',')};`,
  )
  .join('\n')}
}

${colors
  .map(
    (_color, index) => `.bg-accessible-color-${index + 1} {
  background-color: rgb(var(--accessible-color-${index + 1}));
}
.text-accessible-color-${index + 1} {
  color: rgb(var(--accessible-color-${index + 1}));
}`,
  )
  .join('\n')}
`;
  const head = document.getElementsByTagName('head')[0] as HTMLHeadElement;
  head.appendChild(node);
};
